import { FormInput, useFormContext } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useEffect } from "react";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { TTicketAutoTransferRuleForm } from "./TicketAutoTransferRuleSchema";

const translationPath = "page.settings.crm.ticketAutoTransferRules.";

export const Minutes = memo(() => {
  const { t } = useTranslation();

  const { control, setValue } = useFormContext<TTicketAutoTransferRuleForm>();

  const transfer = useWatch({
    name: "transfer",
    control,
  });

  useEffect(() => {
    if (!transfer) {
      setValue("minutes", "");
    }
  }, [setValue, transfer]);

  return (
    <Grid item xs={12} sm={6}>
      <FormInput
        size="small"
        name="minutes"
        type="number"
        fullWidth
        disabled={!transfer}
        label={t(translationPath + "minutes") || "Minutes"}
      />
    </Grid>
  );
});
